import { makeStyles } from '@material-ui/core/styles';
import { Button, Stack, TextField } from '@shopify/polaris';
import React, { useCallback, useState } from 'react';
import { useSWRConfig } from 'swr';
import wait from '../../utils/wait';
import { generateReport, getProjectPage } from '../../utils/woorankApi';
type ReviewCreatorProps = {
  apiKey: string;
  host: string;
};
const useStyles = makeStyles(theme => ({
  createBar: {
    marginBottom: theme.spacing(2)
  }
}));

export default function ReviewCreator ({ apiKey, host }: ReviewCreatorProps) {
  const classes = useStyles();
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const { mutate } = useSWRConfig();
  const pollReview: any = useCallback(async (urlToPoll: string) => {
    const reviewData = await getProjectPage(urlToPoll, apiKey);
    console.log(reviewData);
    if (reviewData.dataCompleteness > 0.1 || reviewData.score) {
      mutate(`/woorank-api/review-page/${host}`);
      setLoading(false);
      setUrl('');
      return;
    }
    await wait(15000);
    return pollReview(urlToPoll);
  }, [apiKey, host, mutate]);
  const createReview = useCallback(async () => {
    const reviewUrl = new URL(url, `https://${host}`);
    setLoading(true);
    const res = await generateReport(reviewUrl.toString(), apiKey);
    pollReview(res.review.url);
  }, [url, apiKey, host, pollReview]);
  return (
    <div className={classes.createBar}>
      <Stack spacing='loose'>
        <Stack.Item fill>
          <TextField
            value={url}
            label={null}
            placeholder='Review a new internal page'
            disabled={loading}
            prefix={`${host}/`}
            onChange={(value) => {
              setUrl(value);
            }}
            autoComplete='off'
          />
        </Stack.Item>
        <Button primary loading={loading} onClick={createReview}>
          Create Review
        </Button>
      </Stack>
    </div>
  );
}
